import Echo from 'laravel-echo'
import io from 'socket.io-client'

window.io = io

const EchoInstance = new Echo({
  broadcaster: 'socket.io',
  host: process.env.VUE_APP_WEBSOCKET_HOST,
  path: process.env.VUE_APP_WEBSOCKET_PATH,
  transports: ['websocket']
})

export default EchoInstance
